export default __webpack_public_path__ + "static/media/slide2.584be5d6.png";